/* eslint-disable import/no-anonymous-default-export */
import axios from './axios';

const URL = process.env.REACT_APP_AUTHENTICATION_URL;

export default {
  login(params) {
    return axios.post(`${URL}/login`, params);
  },
};
